// Single import point for the Vite-stamped build id.
//
// `__LF_BUILD_ID__` is injected by vite.config.ts via `define` (a string
// literal substituted at build time). Declaring the ambient global here — and
// nowhere else — keeps the `declare const` to one site; the rest of the app
// imports the normal `LOADED_BUILD_ID` const.
//
// In a `vite dev` session the constant is still defined (Vite applies `define`
// in dev too), so the loaded id matches what the dev middleware serves at
// /version.json — Tier 2 reports outcome:'same' and never shows a spurious
// banner locally.

declare const __LF_BUILD_ID__: string

export const LOADED_BUILD_ID: string = __LF_BUILD_ID__
